import React from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
import { parseHtml } from "@/utils/common";
const CardDots = dynamic(() => import("@/Components/DataDisplayCompoants/CardDots"),{ssr: true});

interface CardProps {
  desc: string;
}
const Card: React.FC<CardProps> = ({ desc }) => {
  return (
    <div className=" relative group h-full ">
      <div className=" absolute top-0 right-0 w-full h-full">
        <Image
          src="/images/career-yellow-shape-b.png"
          alt="industry bg"
          width={810}
          height={393}
          quality={100}
          className="w-full h-full max-h-full object-cover "
        />
      </div>
      <CardDots />

      <div className="relative z-10 flex items-center justify-center left-0 right-0 py-[26px] max-w-[680px] px-[26px] xl:px-[50px] h-full">
        <p className="text-subtitle-2  mx-auto font-semibold text-primary-text mt-2">
          {parseHtml(desc ?? "")}
        </p>
      </div>
    </div>
  );
};
export default Card;
